import { render, staticRenderFns } from "./AppOrganizationSettingsCard.vue?vue&type=template&id=380cf8f6&scoped=true&"
import script from "./AppOrganizationSettingsCard.vue?vue&type=script&lang=js&"
export * from "./AppOrganizationSettingsCard.vue?vue&type=script&lang=js&"
import style0 from "./AppOrganizationSettingsCard.vue?vue&type=style&index=0&id=380cf8f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380cf8f6",
  null
  
)

export default component.exports